
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexM0XmuIOUouLt6vI6GNdDzXXCF6PSXc10ppzAZDykFl8Meta } from "/app/pages/app/index.vue?macro=true";
import { default as indexuzsgFj9OKkUF06flNXjnqNqC8GsA4MtSyO89qmwHnrUMeta } from "/app/pages/new/index.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as _91slug_93YQZPwPwDU4FgBZuc83y_45fmjjiA1deKiIAVltnUukrBsMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as indexFLj9L2ZLTI58obNxT5mPVCFIfw7GQ8R8qIt0XQbo_45_wMeta } from "/app/pages/shops/index.vue?macro=true";
import { default as indexkIEbRaXbSPuW0J4wRlqApYEFdbEy0aMfHr8BvuPzTZMMeta } from "/app/pages/[slug]/index.vue?macro=true";
import { default as shopsynrrtAVjpPK_U3_45FXuon_i5kyl6iKWv1g5zAaIioEiQMeta } from "/app/pages/[slug]/shops.vue?macro=true";
import { default as index2PYMTDJrpLuKw87XcSdwT4b4Wne8Fi8XVnZfQYbjf_AMeta } from "/app/pages/brands/index.vue?macro=true";
import { default as index_LJrHsPbuv2_DzKUjO6NHt_wORq_w3mqeGqzDMgkezQMeta } from "/app/pages/cities/index.vue?macro=true";
import { default as index9fStvmnJX7wtyuxF4J9xpemZtShahA8HONjn9_45myOpUMeta } from "/app/pages/offers/index.vue?macro=true";
import { default as _91slug_93HwLP8LNkoZrPhDYro4oHcQTBLtWc1y0o3rRivNMmZ5UMeta } from "/app/pages/brands/[slug].vue?macro=true";
import { default as _91slug_93YhtU8jE4sb_ehhzeEa3tL3JpLeJgdwmuOS2DBECVUscMeta } from "/app/pages/cities/[slug].vue?macro=true";
import { default as feature_45flagsNF_ZdqbEg8R2k_456Xb39BUvlNluwqSZcfX5w7pWxgWbgMeta } from "/app/pages/feature-flags.vue?macro=true";
import { default as _91slug_93YBht3ytCrgSPmYQu0ARKWSKUMF1TpcaX_453YSsfXIy5wMeta } from "/app/pages/offers/[slug].vue?macro=true";
import { default as indexoxBGzYZqIPKM6NnWsf42sGIx7qvsJK_45xvAxag797X_45YMeta } from "/app/pages/categories/index.vue?macro=true";
import { default as indexHi6iAnjV7Vzyf9ONPHwHp2FRn3cHilBWMjuI0QT6HsUMeta } from "/app/pages/[slug]-offers/index.vue?macro=true";
import { default as indexYVuq_l1aizZ0ou2eGoaLylR_45PGxjQRTmhOIHh_RTxXAMeta } from "/app/pages/categories/[slug]/index.vue?macro=true";
import { default as _91_91pagenumber_93_93K8n_45SVf5PiqjdRhJB_45NipAn8NtCHWlz35PJ6pb6c4HsMeta } from "/app/pages/embed/[id]/[[pagenumber]].vue?macro=true";
import { default as indexcnHJ2ByGo98nurHydyjvYKtqmFWqJXXR2UDG6dcuNh0Meta } from "/app/pages/search/[searchQuery]/index.vue?macro=true";
import { default as _91_91pagenumber_93_93_TDdfE6ZhhbFSHUlpnAkJIkFTwa4OMk6RTT1Uc80Ye8Meta } from "/app/pages/[slug]-offers/[id]/[[pagenumber]].vue?macro=true";
import { default as _91referenceId_936ndJOzlTMW_vi2S5rQNk4wNfoAf0GY9jw3hLn48GfO8Meta } from "/app/pages/search/[searchQuery]/[type]/[referenceId].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___nl-NL",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "app___nl-NL",
    path: "/app",
    component: () => import("/app/pages/app/index.vue")
  },
  {
    name: "app___nl",
    path: "/nl/app",
    component: () => import("/app/pages/app/index.vue")
  },
  {
    name: "app___fr",
    path: "/fr/app",
    component: () => import("/app/pages/app/index.vue")
  },
  {
    name: "new___nl-NL",
    path: "/nieuw",
    component: () => import("/app/pages/new/index.vue")
  },
  {
    name: "new___nl",
    path: "/nl/nieuw",
    component: () => import("/app/pages/new/index.vue")
  },
  {
    name: "new___fr",
    path: "/fr/nouveaux",
    component: () => import("/app/pages/new/index.vue")
  },
  {
    name: "blog___nl-NL",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___nl",
    path: "/nl/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog-slug___nl-NL",
    path: "/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___nl",
    path: "/nl/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___fr",
    path: "/fr/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "shops___nl-NL",
    path: "/winkels",
    component: () => import("/app/pages/shops/index.vue")
  },
  {
    name: "shops___nl",
    path: "/nl/winkels",
    component: () => import("/app/pages/shops/index.vue")
  },
  {
    name: "shops___fr",
    path: "/fr/magasins",
    component: () => import("/app/pages/shops/index.vue")
  },
  {
    name: "slug___nl-NL",
    path: "/:slug()",
    component: () => import("/app/pages/[slug]/index.vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug()",
    component: () => import("/app/pages/[slug]/index.vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug()",
    component: () => import("/app/pages/[slug]/index.vue")
  },
  {
    name: "slug-shops___nl-NL",
    path: "/:slug()/folder-aanbiedingen",
    component: () => import("/app/pages/[slug]/shops.vue")
  },
  {
    name: "slug-shops___nl",
    path: "/nl/:slug()/folder-aanbiedingen",
    component: () => import("/app/pages/[slug]/shops.vue")
  },
  {
    name: "slug-shops___fr",
    path: "/fr/:slug()/foldre-offres",
    component: () => import("/app/pages/[slug]/shops.vue")
  },
  {
    name: "brands___nl-NL",
    path: "/merken",
    component: () => import("/app/pages/brands/index.vue")
  },
  {
    name: "brands___nl",
    path: "/nl/merken",
    component: () => import("/app/pages/brands/index.vue")
  },
  {
    name: "brands___fr",
    path: "/fr/marques",
    component: () => import("/app/pages/brands/index.vue")
  },
  {
    name: "cities___nl-NL",
    path: "/steden",
    component: () => import("/app/pages/cities/index.vue")
  },
  {
    name: "cities___nl",
    path: "/nl/steden",
    component: () => import("/app/pages/cities/index.vue")
  },
  {
    name: "cities___fr",
    path: "/fr/villes",
    component: () => import("/app/pages/cities/index.vue")
  },
  {
    name: "offers___nl-NL",
    path: "/aanbiedingen",
    component: () => import("/app/pages/offers/index.vue")
  },
  {
    name: "offers___nl",
    path: "/nl/aanbiedingen",
    component: () => import("/app/pages/offers/index.vue")
  },
  {
    name: "offers___fr",
    path: "/fr/offres",
    component: () => import("/app/pages/offers/index.vue")
  },
  {
    name: "brands-slug___nl-NL",
    path: "/merken/:slug()",
    component: () => import("/app/pages/brands/[slug].vue")
  },
  {
    name: "brands-slug___nl",
    path: "/nl/merken/:slug()",
    component: () => import("/app/pages/brands/[slug].vue")
  },
  {
    name: "brands-slug___fr",
    path: "/fr/marques/:slug()",
    component: () => import("/app/pages/brands/[slug].vue")
  },
  {
    name: "cities-slug___nl-NL",
    path: "/steden/:slug()",
    component: () => import("/app/pages/cities/[slug].vue")
  },
  {
    name: "cities-slug___nl",
    path: "/nl/steden/:slug()",
    component: () => import("/app/pages/cities/[slug].vue")
  },
  {
    name: "cities-slug___fr",
    path: "/fr/villes/:slug()",
    component: () => import("/app/pages/cities/[slug].vue")
  },
  {
    name: "feature-flags___nl-NL",
    path: "/feature-flags",
    component: () => import("/app/pages/feature-flags.vue")
  },
  {
    name: "feature-flags___nl",
    path: "/nl/feature-flags",
    component: () => import("/app/pages/feature-flags.vue")
  },
  {
    name: "feature-flags___fr",
    path: "/fr/feature-flags",
    component: () => import("/app/pages/feature-flags.vue")
  },
  {
    name: "offers-slug___nl-NL",
    path: "/aanbiedingen/:slug()",
    component: () => import("/app/pages/offers/[slug].vue")
  },
  {
    name: "offers-slug___nl",
    path: "/nl/aanbiedingen/:slug()",
    component: () => import("/app/pages/offers/[slug].vue")
  },
  {
    name: "offers-slug___fr",
    path: "/fr/offres/:slug()",
    component: () => import("/app/pages/offers/[slug].vue")
  },
  {
    name: "categories___nl-NL",
    path: "/categorieen",
    component: () => import("/app/pages/categories/index.vue")
  },
  {
    name: "categories___nl",
    path: "/nl/categorieen",
    component: () => import("/app/pages/categories/index.vue")
  },
  {
    name: "categories___fr",
    path: "/fr/categories",
    component: () => import("/app/pages/categories/index.vue")
  },
  {
    name: "slug-offers___nl-NL",
    path: "/:slug()-aanbiedingen",
    component: () => import("/app/pages/[slug]-offers/index.vue")
  },
  {
    name: "slug-offers___nl",
    path: "/nl/:slug()-folder",
    component: () => import("/app/pages/[slug]-offers/index.vue")
  },
  {
    name: "slug-offers___fr",
    path: "/fr/:slug()-folder",
    component: () => import("/app/pages/[slug]-offers/index.vue")
  },
  {
    name: "categories-slug___nl-NL",
    path: "/categorieen/:slug()",
    component: () => import("/app/pages/categories/[slug]/index.vue")
  },
  {
    name: "categories-slug___nl",
    path: "/nl/categorieen/:slug()",
    component: () => import("/app/pages/categories/[slug]/index.vue")
  },
  {
    name: "categories-slug___fr",
    path: "/fr/categories/:slug()",
    component: () => import("/app/pages/categories/[slug]/index.vue")
  },
  {
    name: "embed-id-pagenumber___nl-NL",
    path: "/embed/:id()/:pagenumber?",
    meta: _91_91pagenumber_93_93K8n_45SVf5PiqjdRhJB_45NipAn8NtCHWlz35PJ6pb6c4HsMeta || {},
    component: () => import("/app/pages/embed/[id]/[[pagenumber]].vue")
  },
  {
    name: "embed-id-pagenumber___nl",
    path: "/nl/embed/:id()/:pagenumber?",
    meta: _91_91pagenumber_93_93K8n_45SVf5PiqjdRhJB_45NipAn8NtCHWlz35PJ6pb6c4HsMeta || {},
    component: () => import("/app/pages/embed/[id]/[[pagenumber]].vue")
  },
  {
    name: "embed-id-pagenumber___fr",
    path: "/fr/embed/:id()/:pagenumber?",
    meta: _91_91pagenumber_93_93K8n_45SVf5PiqjdRhJB_45NipAn8NtCHWlz35PJ6pb6c4HsMeta || {},
    component: () => import("/app/pages/embed/[id]/[[pagenumber]].vue")
  },
  {
    name: "search-searchQuery___nl-NL",
    path: "/zoekresultaten/:searchQuery()",
    component: () => import("/app/pages/search/[searchQuery]/index.vue")
  },
  {
    name: "search-searchQuery___nl",
    path: "/nl/zoekresultaten/:searchQuery()",
    component: () => import("/app/pages/search/[searchQuery]/index.vue")
  },
  {
    name: "search-searchQuery___fr",
    path: "/fr/resultatdecherche/:searchQuery()",
    component: () => import("/app/pages/search/[searchQuery]/index.vue")
  },
  {
    name: "slug-offers-id-pagenumber___nl-NL",
    path: "/:slug()-aanbiedingen/:id()/:pagenumber?",
    meta: _91_91pagenumber_93_93_TDdfE6ZhhbFSHUlpnAkJIkFTwa4OMk6RTT1Uc80Ye8Meta || {},
    component: () => import("/app/pages/[slug]-offers/[id]/[[pagenumber]].vue")
  },
  {
    name: "slug-offers-id-pagenumber___nl",
    path: "/nl/:slug()-folder/:id()/:pagenumber?",
    meta: _91_91pagenumber_93_93_TDdfE6ZhhbFSHUlpnAkJIkFTwa4OMk6RTT1Uc80Ye8Meta || {},
    component: () => import("/app/pages/[slug]-offers/[id]/[[pagenumber]].vue")
  },
  {
    name: "slug-offers-id-pagenumber___fr",
    path: "/fr/:slug()-folder/:id()/:pagenumber?",
    meta: _91_91pagenumber_93_93_TDdfE6ZhhbFSHUlpnAkJIkFTwa4OMk6RTT1Uc80Ye8Meta || {},
    component: () => import("/app/pages/[slug]-offers/[id]/[[pagenumber]].vue")
  },
  {
    name: "search-searchQuery-type-referenceId___nl-NL",
    path: "/zoekresultaten/:searchQuery()/:type()/:referenceId()",
    component: () => import("/app/pages/search/[searchQuery]/[type]/[referenceId].vue")
  },
  {
    name: "search-searchQuery-type-referenceId___nl",
    path: "/nl/zoekresultaten/:searchQuery()/:type()/:referenceId()",
    component: () => import("/app/pages/search/[searchQuery]/[type]/[referenceId].vue")
  },
  {
    name: "search-searchQuery-type-referenceId___fr",
    path: "/fr/resultatdecherche/:searchQuery()/:type()/:referenceId()",
    component: () => import("/app/pages/search/[searchQuery]/[type]/[referenceId].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/nl/categories/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/nl/nl/categories/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/nl/categories/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]